import type { Theme } from "@mui/material";

/** Distância do AppBar em relação ao topo da viewport (mobile). */
export const MOBILE_HEADER_TOP_GAP = 0;

export const MOBILE_HEADER_COLLAPSED_HEIGHT = 44;
export const MOBILE_HEADER_EXPANDED_HEIGHT = 56;

export function getMobileToolbarHeight(
  isCollapsed: boolean,
  theme: Theme
): number {
  if (isCollapsed) return MOBILE_HEADER_COLLAPSED_HEIGHT;

  const toolbarMin = theme.mixins.toolbar?.minHeight;
  return typeof toolbarMin === "number" ? toolbarMin : MOBILE_HEADER_EXPANDED_HEIGHT;
}

export function getMobileHeaderOffset(
  isCollapsed: boolean,
  theme: Theme
): string {
  const height = getMobileToolbarHeight(isCollapsed, theme);
  return `calc(${MOBILE_HEADER_TOP_GAP}px + ${height}px + env(safe-area-inset-top, 0px))`;
}

export function getMobileContentTopInset(theme: Theme): string {
  return getMobileHeaderOffset(false, theme);
}

export const MOBILE_HEADER_PANEL_Z_INDEX_OFFSET = 45;

export const MOBILE_HEADER_ELEVATED_Z_INDEX_OFFSET = 50;

export function getMobileHeaderPanelZIndex(theme: Theme): number {
  return theme.zIndex.modal + MOBILE_HEADER_PANEL_Z_INDEX_OFFSET;
}

export function getMobileHeaderElevatedZIndex(theme: Theme): number {
  return theme.zIndex.modal + MOBILE_HEADER_ELEVATED_Z_INDEX_OFFSET;
}

export const CHAT_LUXOR_TRIGGER_Z_INDEX_OFFSET = 12;

export const CHAT_LUXOR_PANEL_Z_INDEX_OFFSET = 30;

export function getChatLuxorTriggerZIndex(theme: Theme): number {
  return theme.zIndex.modal + CHAT_LUXOR_TRIGGER_Z_INDEX_OFFSET;
}

export function getChatLuxorPanelZIndex(theme: Theme): number {
  return theme.zIndex.modal + CHAT_LUXOR_PANEL_Z_INDEX_OFFSET;
}
